import { Injectable } from '@angular/core';
import { WorkshopDefect } from '../models/workshop-defect.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkshopInvoicingService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getUninvoicedCompletedDefects(): Observable<WorkshopDefect[]> {
    return this.httpClient.get(this._endpoint + 'workshop-defect?filter=status||eq||complete&filter=invoiceId||isnull')
    .pipe(map((data) => {
      return <WorkshopDefect[]>data;
    }));
  }

  assignWorkshopDefects(defectIds: number[]): Observable<any[]> {
    return this.httpClient.post(this._endpoint + 'invoice/assignWorkshopDefects',
    JSON.stringify({ bulk: defectIds }),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <any[]>data;
    }));
  }
}
